import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '~/@api/client/authStore'
import { Spinner } from '~/shadcn/ui/spinner'
import { useUserOtpLoginMutation } from './useUserOtpLoginMutation'
import { FieldError } from '~/shadcn/ui/field'
import { Button } from '~/shadcn/ui/button/button'

function UserOtpLoginPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setAuthToken } = useAuthStore()
  const { isRequestingUserOtpLogin, userOtpLogin, error } =
    useUserOtpLoginMutation()
  const startedRef = useRef(false)

  const code = searchParams.get('code')

  useEffect(() => {
    if (!code) {
      navigate('/login')
      return
    }

    if (startedRef.current) return
    startedRef.current = true

    userOtpLogin(
      { otpParam: code ?? '' },
      {
        onSuccess: (data) => {
          setAuthToken({
            token: data.auth.token,
            expiration: data.auth.expiration,
          })
          if (data.auth.redirectUrl) {
            setTimeout(
              () => navigate(data.auth.redirectUrl, { replace: true }),
              1
            )
          }
        },
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-12 min-h-full">
        <div className="flex flex-col items-center justify-center gap-12 min-h-full">
          <div className="gap-12 w-full p-4 pb-12 lg:p-0 lg:pb-16">
            {isRequestingUserOtpLogin && <Spinner className="size-10" />}
            {error != null && (
              <>
                <FieldError className="py-4">Odkaz je neplatný</FieldError>
                <Button
                  variant="accent"
                  type="submit"
                  size="lg"
                  className="w-full"
                  onClick={() => {
                    navigate('/login')
                  }}>
                  Prihlásenie
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserOtpLoginPage
